import { boundRuleText, ruleTextBuilderMap } from '@components/summary-panel/MetricFilterBar';
import { get, isEmpty } from 'lodash';
import moment from 'moment';
import { formatCell, TS_FORMAT } from './formatters';

// TODO: multiple
function buildFilterText(appliedFilter) {
  const filters: any = []
  filters.push(`Filter: ${appliedFilter.name}`);
  return filters.join('\r\n');
}

export function buildIntervalText(interval) {
  return `Interval: ${moment(interval.from).format(TS_FORMAT)} to ${moment(interval.to).format(TS_FORMAT)}`;
}

export function buildComparisonIntervalText(interval) {
  return `Date Comparison Interval: ${moment(interval.from).format(TS_FORMAT)} to ${moment(
    interval.to
  ).format(TS_FORMAT)}`;
}

function buildMetricFilterText(metricFilter, metricList) {

  const mfText = metricFilter.map(mf => {
    const { metric, rule, meta } = mf;
    const ruleTextBuilder = get(ruleTextBuilderMap, meta.type, boundRuleText);
    return ruleTextBuilder({ metric, rule, metricList });
  }).join(' AND ');

  return `MetricFilter: ${mfText}`;
}

// applied filter and interval
export const baseParamsParser = ({ sectionData, metricList }) => {
  const parts: any = [];
  const data = get(sectionData, ['base', 'data'], {});
  const { appliedFilter, interval, compareInterval, metricFilter } = data;

  if (appliedFilter) {
    parts.push(buildFilterText(appliedFilter));
  }

  if (!isEmpty(metricFilter)) {
    parts.push(buildMetricFilterText(metricFilter, metricList));
  }

  if (interval) {
    parts.push(buildIntervalText(interval));
  }

  if(compareInterval) {
    parts.push(buildComparisonIntervalText(compareInterval));
  }

  parts.push('\r\n');

  return parts.join('\r\n')
}

export const sectionParserMap = {
  base: baseParamsParser,
}

// convert section to csv
// timeseries, dimensions
// supports object and array formats
// headers - [m1, m2]
// data - { m1: v1, m2: v2 } or [v1, v2]
export function convertDataToCsv({ widgetInfo = {}, headers, data, footerData = [] }) {
  let rows: any = [];

  // skip widget if there's no data
  if (isEmpty(data)) {
    return '';
  }

  if (Array.isArray(data[0])) {
    rows = data.map((row) => {
      return row
        .map((r, i) => JSON.stringify(formatCell(headers[i], r)))
        .join(',');
    });
  } else {
    rows = data.map((row) => {
      return headers
        .map((header) => {
          return JSON.stringify(formatCell(header, row[header.key]));
        })
        .join(',');
    });
  }

  // footerData: [[footerRow1_data], [footerRow2_data], ...[footerRowN_data]]
  if(footerData.length) {
    const footerRows = footerData.map((rows) => {
      return rows.map((row) => JSON.stringify(row)).join(',');
    });

    rows.push(footerRows);
  }

  rows.push('\r\n');

  rows.unshift(headers.map((h) => h.title).join(',')); // add header column
  rows.unshift(widgetInfo.title || '');

  return rows.join('\r\n');
}

// widgets are ordered based on the order specified in config
// if no order is specified, ordering might change between exports
// if there are multiple widgets of similar type use `type::<key>` format
// where type has to match the string in order, see usage of distribution::<metric>
const sortIndexOf = (order, value) => {
  const key = value.split('::')[0];
  const idx = order.indexOf(key);
  return idx === -1 ? Infinity : idx;
}

const orderWidgets = (section, widgetKeys) => {
  if('order' in section) {
    const order = section.order;
    widgetKeys.sort( (a,b) => sortIndexOf(order, a) - sortIndexOf(order, b));
  }
  return widgetKeys;
}

// default widget workflow
export function defaultParser({ section, sectionData }) {
  const parts = [section.title];

  const widgetKeys = orderWidgets(section, Object.keys(sectionData));

  // widgets
  widgetKeys.forEach((widgetKey: any) => {
    const data = sectionData[widgetKey];
    const widgetCsv = convertDataToCsv(data);
    if (widgetCsv) {
      parts.push(widgetCsv);
    }
  });

  return parts.join('\r\n');
}
